import { useCallback, useEffect, useRef } from "react"
import { X } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Popover, PopoverAnchor, PopoverContent } from "@/components/ui/popover"

import { useCartTourStore } from "../store/tour"

interface CartTourProps {
  children: React.ReactNode
}

export function CartTour({ children }: CartTourProps) {
  const { isCartTourVisible, hasSeenCartTour, markCartTourAsSeen } =
    useCartTourStore()
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  // Handle closing the tour
  const handleClose = useCallback(() => {
    markCartTourAsSeen()
  }, [markCartTourAsSeen])

  // Auto-hide after 5 seconds
  useEffect(() => {
    if (isCartTourVisible) {
      timeoutRef.current = setTimeout(() => {
        handleClose()
      }, 10000)

      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current)
        }
      }
    }
  }, [isCartTourVisible, handleClose])

  return (
    <Popover
      open={isCartTourVisible && !hasSeenCartTour}
      onOpenChange={(open) => !open && handleClose()}
    >
      <PopoverAnchor asChild>{children}</PopoverAnchor>
      <PopoverContent className="w-64 p-4 z-[100] relative" align="end">
        {/* Close button */}
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-1 top-1 h-6 w-6"
          onClick={handleClose}
        >
          <X className="h-4 w-4" />
        </Button>

        {/* Content */}
        <div className="space-y-2 pr-4">
          <p className="font-medium text-sm text-gray-900">
            Món ăn đã được thêm vào giỏ hàng!
          </p>
          <p className="text-xs text-gray-600">
            Nhấn vào biểu tượng giỏ hàng để xem và chỉnh sửa đơn hàng của bạn
          </p>
        </div>
      </PopoverContent>
    </Popover>
  )
}
